<template>
  <div id="createLicenseModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ texts.title }}</h5>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="selecionealuno"
              >Selecione o Aluno</label
            >
            <VueMultiselect
              v-model="form['user'].value"
              :class="{
                'is-invalid': v$.form['user'].value.$error,
              }"
              :allow-empty="false"
              :clear-on-select="false"
              :close-on-select="true"
              :options="
                dataAluno.map((aluno) => ({ id: aluno.id, name: aluno.name }))
              "
              label="name"
              deselectLabel=""
              placeholder="Selecione o aluno"
              selectLabel=""
              selectedLabel=""
              showNoResults="true"
            />
            <div>
              <span
                v-if="v$.form['user'].value.$error"
                class="invalid-feedback"
              >
                {{ form["user"].message }}
              </span>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="selecionealuno">CID</label>
            <VueMultiselect
              v-model="form['cid'].value"
              :allow-empty="true"
              :clear-on-select="false"
              :close-on-select="true"
              :options="
                dataCID.map((cid) => cid.code + ' - ' + cid.description)
              "
              deselectLabel=""
              placeholder="Selecione o CID"
              selectLabel=""
              selectedLabel=""
              showNoResults="true"
            />
          </div>

          <div class="mb-3">
            <label class="form-label" for="start">Data Inicial</label>
            <input
              id="start"
              v-model="form['start'].value"
              class="form-control"
              name="start"
              type="date"
              @keyup="validateDate"
            />
          </div>

          <div class="mb-3">
            <label class="form-label" for="end">Data Final</label>
            <input
              id="end"
              v-model="form['end'].value"
              :class="{
                'is-invalid': this.form['end'].error,
              }"
              class="form-control"
              name="end"
              type="date"
              @keyup="validateDate"
            />
            <div>
              <span v-if="this.form['end'].error" class="invalid-feedback">
                {{ form["end"].message }}
              </span>
            </div>
          </div>

          <div class="mb-3">
            <label class="mb-2 form-label" for="licenseFile">Licença </label>
            <label class="w-100 label-file" for="file">
              <div class="text-center button-file">
                <img alt="Carregar arquivo" src="../../assets/svg/disk.svg" />
                <span>Escolher arquivo</span>
                <input
                  id="licenseFile"
                  :class="{
                    'is-invalid': form['document'].error,
                  }"
                  @change="onFileSelected"
                  accept="application/pdf"
                  class="input-file"
                  name="document"
                  type="file"
                />
              </div>
              <input
                :placeholder="form['document'].name"
                class="w-100 field-submit-file"
                readonly
              />
            </label>
            <div>
              <span v-if="form['document'].error" class="invalid-feedback">
                {{ form["document"].message }}
              </span>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label" for="uf">Motivo</label>
            <select
              v-model="form['type'].value"
              :class="{
                'is-invalid': v$.form['type'].value.$error,
              }"
              aria-label="Selecione um type"
              class="form-select"
              name="Motivo"
            >
              <option selected value="">Selecione um motivo</option>
              <option v-for="type in motivos" :key="type" :value="type">
                {{ type.name }}
              </option>
            </select>
            <div>
              <span
                v-if="v$.form['type'].value.$error"
                class="invalid-feedback"
              >
                {{ form["type"].message }}
              </span>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label" for="description">Observação</label>
            <input
              id="description"
              v-model="form['description'].value"
              class="form-control"
              name="endereco"
              placeholder="Digite aqui uma observação"
              type="text"
            />
          </div>
        </div>
        <div class="button-container">
          <button aria-label="Close" class="btn-cancel" data-bs-dismiss="modal">
            Fechar
          </button>

          <button
            id="search-button"
            class="btn-search"
            type="button"
            @click="registerLicense"
            :disabled="loading"
          >
            {{ texts.button }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { LicenseService } from "../../services";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "CreateLicenseModal",
  components: {
    VueMultiselect,
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      /**
       * Conjunto de dados e estruturas utilizadas no contexto do componente de licenças.
       * @namespace
       * @property {Array<any>} dataAluno - Dados dos alunos relacionados à licença.
       * @property {Array<any>} dataCID - Dados das CIDs (Classificação Internacional de Doenças) relacionadas à licença.
       * @property {Array<any>} motivos - Dados dos motivos relacionados à licença.
       * @property {object} form - Estrutura do formulário de cadastro de licença.
       * @property {object} texts - Textos utilizados no modal.
       * @property {Function | null} operationFunction - Função de operação associada ao formulário (Create ou Update).
       */

      dataAluno: [],
      dataCID: [],
      motivos: [],

      form: {
        user: {
          name: "user",
          message: "Por favor, selecione um usuário.",
          value: null,
        },
        cid: {
          name: "cid",
          value: null,
        },
        start: {
          name: "start",
          value: "",
        },
        end: {
          name: "end",
          message: "Por favor, selecione uma data final.",
          value: "",
          error: false,
        },
        type: {
          name: "type",
          message: "Por favor, selecione um motivo.",
          value: "",
        },
        description: {
          name: "description",
          value: "",
        },
        document: {
          name: "Selecione um arquivo",
          message: "Por favor, selecione um arquivo.",
          value: null,
          error: false,
        },
      },

      texts: {
        title: "Cadastrar licença",
        button: "Cadastrar",
      },

      operationFunction: null,
      licenseID: null,
      loading: false,
    };
  },

  async created() {
    // Obtém os dados dos usuários para preenchimento do formulário
    this.dataAluno = await this.getLicenseUsers();

    // Obtém os dados dos CIDs (Classificação Internacional de Doenças)
    this.dataCID = await this.getCid();

    // Obtém os tipos de licença disponíveis
    this.motivos = await this.getTypes();
  },

  validations() {
    return {
      form: {
        user: {
          value: { required },
        },
        type: {
          value: { required },
        },
      },
    };
  },

  methods: {
    /**
     * Executa ações com base na operação.
     * - Se o modo for "Create", limpa os dados, atualiza textos e define a função de operação como criar uma licença.
     * - Se o modo for "Update", obtém informações da licença, atualiza textos e define a função de operação como atualizar uma licença.
     * @function
     */
    verifyOperation(operation, licenseID) {
      switch (operation) {
        case "Create":
          // Limpa os dados do modal antes de criar uma nova licença
          this.clearData();
          // Atualiza os textos para refletir a ação de cadastrar uma licença
          this.updateTexts("Cadastrar licença", "Cadastrar");
          // Define a função de operação como criar uma licença
          this.operationFunction = this.createLicense;
          return;
        case "Update":
          // Armazena o ID da licença para usar na função de update
          this.licenseID = licenseID;
          // Obtém informações da licença a ser atualizada
          this.getLicense(licenseID);
          // Atualiza os textos para refletir a ação de atualizar uma licença
          this.updateTexts("Atualizar licença", "Atualizar");
          // Define a função de operação como atualizar uma licença
          this.operationFunction = this.updateLicense;
          return;
      }
    },

    /**
     * Cria uma nova licença utilizando os dados do formulário.
     * @async
     * @function
     * @throws {Error} Lança um erro se houver algum problema ao criar a licença.
     */
    async createLicense() {
      /**
       * Cria um objeto FormData com os dados do formulário.
       * @type {FormData}
       */
      const formData = this.createFormData();

      try {
        // Envia os dados do formulário para o serviço LicenseService para criar uma nova licença
        await LicenseService.postCreateLicense(formData);
      } catch (error) {
        throw new Error("Erro ao criar licença");
      }
    },

    /**
     * Atualiza uma licença existente utilizando os dados do formulário.
     *
     * @async
     * @function
     * @throws {Error} Lança um erro se houver algum problema ao atualizar a licença.
     */
    async updateLicense() {
      /**
       * Cria um objeto FormData com os dados atualizados do formulário.
       * @type {FormData}
       */
      const formData = this.createFormData();

      try {
        // Envia os dados atualizados do formulário para o serviço LicenseService para atualizar a licença pelo ID
        await LicenseService.updateLicenseById(this.licenseID, formData);
      } catch (error) {
        throw new Error("Erro ao atualizar licença");
      }
    },

    /**
     * Cria e retorna um objeto FormData com os dados do formulário para enviar como multipart/form-data.
     *
     * @function
     * @returns {FormData} Um objeto FormData com os campos do formulário para enviar como multipart/form-data.
     */
    createFormData() {
      const fields = [
        "user",
        "cid",
        "start",
        "end",
        "type",
        "description",
        "document",
      ];

      // Criar um objeto FormData para enviar dados como multipart/form-data
      const formData = new FormData();

      // Adicionar os campos ao FormData
      for (let field of fields) {
        if (this.form[field].value) {
          formData.append(field, this.getValueForField(field));
        }
      }

      return formData;
    },

    /**
     * Obtém o valor correspondente ao campo especificado do formulário.
     *
     * @param {string} field - Campo do formulário a ser processado.
     * @returns {string} - O valor correspondente ao campo especificado.
     */
    getValueForField(field) {
      switch (field) {
        case "user":
          /**
           * Obtém o ID do usuário com base no nome selecionado no formulário.
           * @type {string}
           */
          return this.getIDForData(
            this.form["user"].value.name,
            this.dataAluno,
            "id",
            "name"
          );
        case "cid":
          /**
           * Obtém o ID do CID (Classificação Internacional de Doenças) com base no código selecionado no formulário.
           * @type {string}
           */
          return this.getIDForData(
            this.form["cid"].value.split(" - ")[1],
            this.dataCID,
            "code",
            "description"
          );
        case "type":
          /**
           * Obtém o ID do motivo da licença com base no nome selecionado no formulário.
           * @type {string}
           */
          return this.getIDForData(
            this.form["type"].value.name,
            this.motivos,
            "id",
            "name"
          );
        default:
          return this.form[field].value;
      }
    },

    /**
     * Atualiza os textos utilizados no componente com os valores fornecidos.
     * @function
     * @param {string} title - O novo título a ser atribuído.
     * @param {string} button - O novo texto para o botão a ser atribuído.
     */
    updateTexts(title, button) {
      // Atribui o novo título e texto do botão aos textos do componente
      this.texts.title = title;
      this.texts.button = button;
    },

    /**
     * Obtém os detalhes de uma licença com base no ID da licença atualmente selecionada.
     * Atualiza os campos do formulário com os detalhes da licença obtida.
     * @async
     * @function
     * @param {string} licenseID - ID da licença.
     * @throws {Error} Lança um erro se houver algum problema ao buscar a licença.
     */
    async getLicense(licenseID) {
      try {
        // Obtém os detalhes da licença usando o ID da licença
        const response = await LicenseService.getLicenseById(licenseID);

        // Atualiza os campos do formulário com os detalhes da licença obtida
        this.form["user"].value = { id: response.user_id, name: response.user };
        this.form["cid"].value = response.cid;
        this.form["start"].value = this.formatDate(response.start);
        this.form["end"].value = this.formatDate(response.end);
        this.form["type"].value = {
          id: response.type_id,
          name: response.type,
        };
        this.form["description"].value = response.description;
        // Texto para indicar se o document foi enviado
        this.form["document"].name = response.document
          ? "Documento enviado"
          : "Selecione um arquivo";
      } catch (error) {
        // Em caso de erro ao buscar a licença, lança uma exceção
        throw new Error("Erro ao buscar licença.");
      }
    },

    /**
     * Manipula a seleção de arquivo pelo usuário.
     *
     * @function
     * @param {Event} event - O evento acionado ao selecionar um arquivo.
     */
    onFileSelected(event) {
      // Armazena o arquivo selecionado pelo usuário
      let fileSelected = event.target.files[0];
      // Armazena o tipo do arquivo selecionado
      let fileType = fileSelected.type;
      // Armazena os tipos de arquivos aceitos
      let acceptedTypes = ["application/pdf"];
      // Variável para armazenar o arquivo
      let file = null;
      // Variável que armazena a mensagem de erro
      let message = "Por favor, selecione um arquivo.";
      // Armazena o nome do arquivo
      let fileName = fileSelected.name;

      // Verifica se o arquivo selecionado é um PDF, caso não seja, retorna uma mensagem
      if (!acceptedTypes.includes(fileType)) {
        message =
          "Por favor, selecione um arquivo com formato válido (apenas PDF).";
        file = null;
        // Retira o arquivo do input
        event.target.value = "";
      } else {
        // Atribui o objeto do arquivo selecionado à variável file
        file = fileSelected;
      }

      // Verifica se o arquivo selecionado é maior que 20MB, caso seja, retorna uma mensagem de erro
      if (fileSelected.size > 20971520) {
        message = "Por favor, selecione um arquivo com tamanho máximo de 20MB.";
        file = null;

        // Retira o arquivo do input
        event.target.value = "";
      }

      // Quando há erro o valor da variável file será null
      if (file == null) {
        this.form["document"].error = true;
        this.form["document"].name = "Nome do arquivo";
      } else {
        this.form["document"].error = false;
        this.form["document"].name = fileName;
      }

      this.form["document"].value = file;
      this.form["document"].message = message;
    },

    /**
     * Obtém o ID correspondente a um determinado valor de uma propriedade específica de um conjunto de dados.
     * @function
     * @param {*} value - O valor a ser procurado nos dados.
     * @param {Array} data - O conjunto de dados onde a busca será realizada.
     * @param {string} idPropName - O nome da propriedade que contém os IDs nos dados.
     * @param {string} valuePropName - O nome da propriedade que contém os valores a serem comparados.
     * @returns {*} O ID correspondente ao valor especificado, se encontrado; caso contrário, retorna undefined.
     */
    getIDForData(value, data, idPropName, valuePropName) {
      for (let datum of data) {
        if (datum[valuePropName] === value) {
          return datum[idPropName];
        }
      }
    },

    /**
     * Obtém os tipos de licença disponíveis.
     * @async
     * @function
     * @throws {Error} Lança um erro se houver algum problema ao obter os tipos de licença.
     * @returns {Promise<Array>} Uma promessa que resolve para um array contendo os tipos de licença disponíveis.
     */
    async getTypes() {
      try {
        return await LicenseService.getTypes();
      } catch (error) {
        throw new Error("Erro ao obter tipos");
      }
    },

    /**
     * Obtém uma lista com todos os usuários (alunos).
     * @async
     * @function
     * @throws {Error} Lança um erro se houver algum problema ao obter os usuários relacionados às licenças.
     * @returns {Promise<Array>} Uma promessa que resolve para um array contendo os usuários (alunos).
     */
    async getLicenseUsers() {
      try {
        return await LicenseService.getAllUsers();
      } catch (error) {
        throw new Error("Erro ao obter usuário");
      }
    },

    /**
     * Obtém os CIDs (Classificação Internacional de Doenças).
     * @async
     * @function
     * @throws {Error} Lança um erro se houver algum problema ao obter os códigos CID.
     * @returns {Promise<Array>} Uma promessa que resolve para um array contendo os CIDs.
     */
    async getCid() {
      try {
        return await LicenseService.getCids();
      } catch (error) {
        throw new Error("Erro ao obter CID's");
      }
    },

    /**
     * Valida o formulário e verifica se não há erros de validação nos campos.
     *
     * @async
     * @function
     * @returns {Promise<boolean>} Uma promessa que resolve para um valor booleano.
     */
    async validForm() {
      // Executa a validação dos campos do formulário
      await this.v$.$validate();

      // Verifica se há erros de validação no formulário ou no campo "dataFinal"
      return !(this.v$.$error || this.form["end"].error);
    },

    /**
     * Registra uma nova licença após validar o formulário.
     *
     * @async
     * @function
     */
    async registerLicense() {
      /**
       * Verifica se o formulário é válido.
       * @type {boolean}
       */
      this.loading = true;
      const isValid = await this.validForm();

      if (isValid) {
        // Executa a função de operação (criar ou atualizar licença) após validar o formulário
        await this.operationFunction();

        // Limpa os dados do formulário
        this.clearData();

        // Atualiza os dados da tabela que exibe as licenças
        this.updateDataTable();

        // Esconde o modal de criação/atualização de licença
        this.$parent.hideCreateLicenseModal();

        // Reseta o estado do formulário para indicar que não há alterações pendentes
        this.resetDirtyForm();
      }

      this.loading = false;
    },

    /**
     * Limpa os dados do formulário, definindo valores vazios nos campos e restaurando valores padrão, se aplicável.
     *
     * @function
     */
    clearData() {
      // Define valores vazios nos campos do formulário para limpar os dados
      this.form["user"].value = "";
      this.form["cid"].value = "";
      this.form["start"].value = "";
      this.form["end"].value = "";
      this.form["type"].value = "";
      this.form["description"].value = "";

      // Define um valor padrão para o campo "document" e o nome do arquivo selecionado
      this.form["document"].value = "";
      this.form["document"].name = "Selecione um arquivo";
    },

    /**
     * Atualiza os dados na tabela ou componente que exibe informações de licenças.
     *
     * @function
     */
    updateDataTable() {
      // Chama a função "updateData()" do componente pai para atualizar os dados na tabela ou componente
      this.$parent.updateData();
    },

    /**
     * Reseta o estado do formulário, removendo marcações de sujeira (dirty) e erros.
     *
     * @function
     */
    resetDirtyForm() {
      // Reseta o estado de sujeira (dirty) do formulário para indicar ausência de alterações pendentes
      this.v$.$reset();

      // Define o estado de erro do campo "dataFinal" como falso para limpar qualquer erro anterior
      this.form["end"].error = false;
    },

    /**
     * Valida as datas de início e fim no formulário.
     *
     * @function
     */
    validateDate() {
      /**
       * Cria objetos Date com base nas datas de início e fim fornecidas no formulário.
       * @type {Date}
       */
      const startDate = new Date(this.form["start"].value);
      const endDate = new Date(this.form["end"].value);

      /**
       * Define a mensagem padrão para o campo "end".
       * @type {string}
       */
      let message = "Por favor, selecione uma data final.";

      /**
       * Define o estado de erro padrão para o campo "dataFinal".
       * @type {boolean}
       */
      let error = false;

      // Verifica se a data de início é maior que a data de fim
      if (startDate > endDate) {
        // Atualiza a mensagem e define um erro se a data de início for maior que a data de fim
        message = "A data de início não pode ser maior que a data de fim.";
        error = true;
      }

      // Define a mensagem e o estado de erro no campo "dataFinal"
      this.form["end"].message = message;
      this.form["end"].error = error;
    },

    /**
     * Formata a data do formato dd/MM/yyyy para o formato yyyy-MM-dd
     *
     * @function
     */
    formatDate(date) {
      if (date) {
        date = date.split("/");
        let day = date[0];
        let month = date[1];
        let year = date[2];

        // Formato esperado pelo input é yyyy-MM-dd
        return `${year}-${month}-${day}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

#no-results {
  margin-top: 1rem;
}
/* ESTILIZAÇÃO DA NOTIFICAÇÃO */
.invalid-feedback {
  display: block;
  font-size: 20px;
}

.red {
  color: #ca2323 !important;
}

.form-control.is-invalid {
  border-color: #dc3545 !important;
}

/* INPUT FILE */

input[type="file"] {
  cursor: pointer;
}

.input-file {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.label-file {
  display: flex;
}

.button-file {
  position: relative;
  width: 210px;
  border: hidden;
  border-radius: 10px 0 0 10px;
  color: #004a8a;
  cursor: pointer;
  font-weight: 700;
  background: #e0e0e0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
  padding: 1.15em 1em;
}

.button-file img {
  margin-right: 5px;
}

.field-submit-file {
  width: 75%;
  border: 1px solid #282828;
  border-radius: 0 10px 10px 0;
  background-color: #fff;
  color: #282828;
  cursor: pointer;
  padding: 1.15em 1.5em;
}

.field-submit-file.inconsistent-background {
  background-color: rgba(255, 0, 0, 0.05);
}

.input-file:disabled {
  cursor: default;
}

.field-submit-file:disabled {
  background-color: #e9ecef;
  color: #282828;
  cursor: default;
}

.field-submit-file.is-invalid {
  border-color: #dc3545;
}
/* ESTILIZAÇÃO DO MODAL */

h5 {
  color: #004a8a;
}

.modal-content {
  border-radius: 10px;
  padding: 2rem;
}

.modal-header {
  border-bottom: none;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 0;
}

.modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.modal-footer {
  border-top: none;
  justify-content: center;
}

.on-search {
  margin-top: 1rem;
  border-top: 1px solid #e5e5e5;
}

/* ESTILIZAÇÃO DO BOTÃO */

.button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

button {
  width: 45%;
  padding: 1em 2em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
}

button:not([disabled]):hover {
  background-color: #5aad31;
  cursor: pointer;
}

button:disabled {
  background-color: #e0e0e0;
}

button.btn-cancel {
  background-color: #828282;
}

/* ESTILIZAÇÃO DA TABELA */

td:first-child,
th:first-child {
  border-radius: 10px 0 0 10px;
}

td:last-child,
th:last-child {
  border-radius: 0 10px 10px 0;
}

thead {
  background-color: #004a8a;
  color: #fff;
}

th:nth-child(1),
td:nth-child(1) {
  text-indent: 1em;
}

td:last-child {
  font-weight: bold;
}

tbody {
  background-color: #e0e0e0;
}

.table {
  border-spacing: 0 15px;
  border-collapse: separate;
  border-spacing: 0 16px;
}

th,
td {
  text-align: center;
  padding: 1em 0;
  border-style: unset;
  vertical-align: middle;
}

/* ESTILIZAÇÃO DAS LABELS E INPUTS */

label.form-label {
  color: rgb(130, 130, 130);
}

input[type="text"],
input[type="date"],
select {
  border-radius: 10px;
  border-color: #282828;
  padding: 0.875em 1.5em;
}

@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .button-container {
    align-items: center;
    flex-direction: column-reverse;
  }

  .btn-cancel {
    margin-top: 0.5em;
  }
}
</style>

<style>
/* ESTILIZAÇÃO DO SELECT COM SEARCH */

.multiselect__tags {
  min-height: 40px;
  display: block;
  border-radius: 10px;
  border: 1px solid #282828;
  padding: 11.43px 40px 3.44px 25px;
  background: #fff;
  font-size: 16px;
  overflow: hidden;
  transition: all 0.5s;
}

.multiselect__option--highlight {
  background: #004a8a !important;
}

.multiselect__option--highlight:after {
  background: #004a8a !important;
}

.multiselect__single,
.multiselect__input {
  padding: 0 0 0 0;
  margin-top: 5px;
  margin-bottom: 12px;
}

.multiselect__select {
  top: 9px;
  background-color: transparent;
}

.multiselect__placeholder {
  white-space: nowrap;
  color: #212529;
}

.multiselect--disabled {
  background-color: white;
  opacity: 1;
}

.multiselect--disabled .multiselect__tags {
  background-color: #e9ecef;
  border-color: #282828;
  color: #212529;
  border-radius: 10px;
}

.multiselect__single {
  background-color: transparent;
}

.is-invalid .multiselect__tags {
  border-color: #dc3545;
}

.multiselect.inconsistent-background .multiselect__tags {
  background-color: rgba(255, 0, 0, 0.05);
}

.multiselect.inconsistent-background {
  background-color: transparent;
}
</style>
